import styled from 'styled-components';

export const HeaderCell = styled.th`
  background-color: #f2f3f8 !important;
  color: #454a67 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;

  span {
    font-size: 9px;
  }

  &.paddingY {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  &.col-store {
    width: 250px;
  }

  &.col-last7days {
    width: 154px;
  }

  &.col-stocktype {
    width: 30px;
  }

  &.col-stock {
    width: 130px;
  }

  &.col-duration {
    width: 10px;
  }

  &.col-projection {
    width: 90px;
    background-color: #f2f3f8 !important;
    color: #5062f0 !important;
    border-left: 1px solid #010311;
  }

  &.col-order {
    background-color: #cbd0fb !important;
    color: #5062f0 !important;
    width: 147px;
  }
`;

export const Cell = styled.td`
  font-size: 14px;
  color: #010311;
  white-space: nowrap;

  &.col-store,
  &.col-last7days,
  &.col-stock {
    max-width: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.colData {
    width: 500px;
  }

  span {
    font-size: 12px;
    max-width: 100%;

    &.navyText {
      color: #1f2445;
    }

    &.slateText {
      color: #454a67;
    }

    &.blackText {
      color: #010311;
    }
  }

  &.col-stock {
    color: #5062f0;
  }

  &.col-projection {
    border-left: 1px solid #010311;
  }
`;

export const OrderCellInput = styled.td`
  background-color: #cbd0fb !important;
  text-align: center;

  padding-right: 4px !important;
`;

export const Footer = styled.tr`
  background-color: #e6e7f0;

  td {
    border-top: 1px solid #010311;
  }
`;

export const Input = styled.input`
  width: 100px;
  height: 20px;
  padding: 4px 2px;
  border: none;
  border-bottom: 1px solid #000;
  background-color: #fff;
  font-size: 12px;
  text-align: right;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

export const IconDownload = styled.div`
  cursor: pointer;
`
